import { fg } from '@atlaskit/platform-feature-flags/fg';

import { DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI } from '../../../types/default-cloud-graph-devinfo-branch-entity-ati';
import { DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI } from '../../../types/default-cloud-graph-devinfo-commit-entity-ati';
import { DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI } from '../../../types/default-cloud-graph-devinfo-pull-request-entity-ati';
import { DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI } from '../../../types/default-cloud-graph-devinfo-repository-entity-ati';
import { DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI } from '../../../types/default-cloud-graph-document-entity-ati';
import { DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI } from '../../../types/default-cloud-graph-work-item-entity-ati';
import type { FilterId } from '../../../types/filters';
import { type ThirdPartyConfig } from '../../../types/schemas/types';
import { isAnyCodeSearchEnabled } from '@atlassian/search-common/code-search-mode';
import {
	TypeFilterValueKey,
	type TypeFilterValue3PEntities,
} from '../../../utils/filters/universalType';
import { get3PLogo } from '../../icons';
import { ProductResourceTypes3P } from '../types';

import { GithubIcon, GithubSearchResultIcon } from './icon';

const getGithubTypeFilterConfig = () => {
	const config = new Map<TypeFilterValueKey, TypeFilterValue3PEntities>();

	config.set(TypeFilterValueKey.Repository, {
		entities3P: DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI,
		subTypes3P: [],
	});

	config.set(TypeFilterValueKey.PullRequest, {
		entities3P: DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI,
		subTypes3P: [],
	});

	config.set(TypeFilterValueKey.Branch, {
		entities3P: DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI,
		subTypes3P: [],
	});

	config.set(TypeFilterValueKey.Commit, {
		entities3P: DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI,
		subTypes3P: [],
	});

	config.set(TypeFilterValueKey.DevopsWorkItem, {
		entities3P: DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI,
		subTypes3P: [],
	});

	// The Document type option exists in both code search modes.
	if (isAnyCodeSearchEnabled()) {
		config.set(TypeFilterValueKey.Document, {
			entities3P: DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI,
			subTypes3P: [],
		});
	}

	return config;
};

export const githubConfig: ThirdPartyConfig = {
	displayName: 'GitHub',
	id: 'github',
	resourceType: ProductResourceTypes3P.Github,
	icon: get3PLogo(GithubIcon, 'Github', 'medium'),
	searchResultIcon: get3PLogo(GithubSearchResultIcon, 'Github', 'large'),
	integrationAri: 'ari:cloud:platform::integration/github',
	get typeFilterConfig() {
		return getGithubTypeFilterConfig();
	},
	get filters(): FilterId[] {
		const baseFilters: FilterId[] = [
			'lastUpdated',
			'onlyTitleMatch',
			'pullRequestStatus',
			'reviewer',
			'createdBy',
			'repository',
		];
		if (fg('rovo_fps_show_github_assignee_filter')) {
			baseFilters.push('assignee');
		}
		return baseFilters;
	},
	requiresOauth: true,
	isEnabled: () => true,
};
